import cx from 'classnames';
import { TriangleRounded } from 'education-icons';
import React from 'react';

import { TEXT_WEIGHT, UI_KIT_TEXT_TYPOGRAPHY } from '../constants';
import { H2 } from '../header-text/header-text';
import Image from '../image/image';
import Text from '../text/text';

import { ShowcaseLessonCardFooter } from './__footer/showcase-lesson-card__footer';
import { b } from './cn';

import './showcase-lesson-card.scss';

interface Props {
    title?: string;
    description?: string;
    image?: string;
    badgeNumber?: number;
    assignedCount?: number;
    rating?: number; // 0-5
    onClick?: () => void;
    mix?: string;
}

export const ShowcaseLessonCard = ({
    title,
    description,
    image,
    badgeNumber,
    assignedCount,
    rating,
    onClick,
    mix,
}: Props) => {
    return (
        <>
            <div className={cx(b(), mix)}>
                <div className={b('content', { 'with-pointer': !!onClick })} onClick={onClick}>
                    {!!badgeNumber && (
                        <div className={b('badge')}>
                            <TriangleRounded className={b('badge-triangle')} />
                            <Text className={b('badge-number')} typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphLRegular}>
                                {badgeNumber}
                            </Text>
                        </div>
                    )}
                    <div className={b('content-text')}>
                        {title && (
                            <H2 mix={b('title')} weight={TEXT_WEIGHT.L}>
                                {title}
                            </H2>
                        )}
                        {description && (
                            <Text className={b('description')} size={Text.SIZE.L}>
                                {description}
                            </Text>
                        )}
                    </div>
                    <div className={b('image-wrapper')}>
                        <Image className={b('image')} src={image} />
                    </div>
                </div>
                <ShowcaseLessonCardFooter assignedCount={assignedCount} rating={rating} />
            </div>
        </>
    );
};
